export const countBy = <T>(arr: T[], predicate: (item: T) => boolean): number => {
  let count = 0;

  for (const item of arr) {
    if (predicate(item)) {
      count += 1;
    }
  }

  return count;
};
